import { CONTACT_NOTICE, waLink } from "@/lib/site";

export function WhatsAppIcon({ className = "h-4 w-4" }) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
            <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.87 9.87 0 0 0 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91S17.5 2 12.04 2zm0 18.03a8.1 8.1 0 0 1-4.13-1.13l-.3-.18-3.07.81.82-3-.2-.31a8.08 8.08 0 0 1-1.24-4.31c0-4.47 3.64-8.11 8.12-8.11a8.1 8.1 0 0 1 8.11 8.11c0 4.48-3.64 8.12-8.11 8.12zm4.45-6.08c-.24-.12-1.44-.71-1.66-.79-.22-.08-.39-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.53.06-.24-.12-1.03-.38-1.96-1.21-.72-.64-1.21-1.44-1.35-1.68-.14-.24-.02-.37.11-.5.11-.11.24-.28.37-.42.12-.14.16-.24.24-.4.08-.16.04-.31-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42h-.47c-.16 0-.43.06-.65.31-.22.24-.86.84-.86 2.05 0 1.21.88 2.37 1 2.53.12.16 1.72 2.63 4.18 3.69.58.25 1.04.4 1.4.52.59.19 1.12.16 1.54.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.05.14-1.16-.06-.1-.22-.16-.46-.28z" />
        </svg>
    );
}

export default function WhatsAppCTA({
    phone,
    projectName,
    message,
    label = "WhatsApp Developer",
    testid = "whatsapp-cta",
    large = false,
    className = "",
}) {
    return (
        <a
            href={waLink(phone, projectName, message)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={testid}
            className={`inline-flex items-center justify-center gap-2.5 rounded-full bg-[#1EBE5D] font-semibold text-obsidian transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#25D366] hover:shadow-[0_12px_40px_-10px_rgba(37,211,102,0.5)] ${
                large ? "px-8 py-4 text-base" : "px-5 py-2.5 text-sm"
            } ${className}`}
        >
            <WhatsAppIcon className={large ? "h-5 w-5" : "h-4 w-4"} />
            {label}
        </a>
    );
}

export function ContactNotice({ className = "" }) {
    return (
        <p
            data-testid="contact-consent-notice"
            className={`max-w-md text-[11px] leading-relaxed text-dim ${className}`}
        >
            {CONTACT_NOTICE}
        </p>
    );
}
